import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';


@Component({
  selector: 'asax-result-table-search-table-cell-popover',
  templateUrl: './cell-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .result-table-popover.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-cell {
      font-size: 11px !important;
    }

    .result-table-popover.similarity-table.ngx-datatable.material .datatable-body .datatable-body-row .datatable-body-group-cell {
      font-size: 11px !important;
    }

    .result-table-popover.similarity-table.ngx-datatable.material .datatable-header .datatable-header-cell {
      font-size: 10px !important;
    }

    .result-table-popover.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell {
      white-space: normal !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class CellPopoverComponent {
  @Input() text: string;
}

